export default "__VITE_ASSET__t82bhhdc__"